export default "__VITE_ASSET__O5m2avG9__"